import $api from '../services';

export default {
    login(params) {
        return $api.post('/sign-in', params);
    },
    signUp(params) {
        return $api.post('/sign-up', params);
    },
    passwordSendEmail(email) {
        return $api.post('/password/reset', { email });
    },
    confirmPassword(params) {
        return $api.post('/password/confirm', params);
    },
    confirmEmail(params) {
        return $api.post('/email/confirm', params);
    },
    validateEmail(email) {
        return $api.post('/email/validate', email);
    },
    resendEmail(email) {
        return $api.post('/email/resend', email);
    }
};
